import type { FC } from 'react';

import { Overlay } from '../../Overlay/Overlay';
import { useChameleonExperiment } from '../../utils/useChameleonExperiment';

import * as styles from './AccountSharingPopup.module.scss';

const CHAMELEON_PATH =
  'https://chameleon.vg.no/chameleon-api/route/vgtv-content-block/?iframeId=popup_iframe';

interface AccountSharingPopupProps {
  isOpen: boolean;
}

export const AccountSharingPopup: FC<AccountSharingPopupProps> = ({
  isOpen,
}) => {
  const iframe = useChameleonExperiment({
    shouldRender: isOpen,
    url: CHAMELEON_PATH,
  });

  return (
    <Overlay
      type="overlay/popup"
      isOpen={isOpen}
      contentClassName={styles.content}
    >
      {iframe}
    </Overlay>
  );
};
